import Conexion_api from "@/api/Conexion_api.js";

/*Evento para registrar nuevo contacto en la plataforma, no es necesario notificar al cliente del registro,
se enviara correo al administrador en caso de error*/
const registrar_contacto = function(registro){    
  Conexion_api({
      body: {
        ...registro
      },
      evento: "pedidos_enterprise/registrar_contacto"
  })
  .then(respuesta => {   
    if(respuesta.data.error){                     
      console.error(respuesta.data.error);
      return;
    }           
  })
  .catch(err => {     
    err = String(err)                
    console.error(err)
  }) 
}
export default registrar_contacto